<script lang="jsx">
import { map } from '../lib'
import DropDown from './DropDown.vue'
import Help from './HelpText'
import Input from './Input'

const _addItem = (addItem, fields, scope) => () => {
  addItem()
  setTimeout(() => {
    const inputs = document.querySelectorAll(`#${scope} .removable-input input`)
    const last = inputs[inputs.length - fields]
    if (last) last.focus()
  }, 0)
}

const DynamicInput = (
  {
    id: _id,
    label,
    placeholder,
    fields,
    items,
    addItem,
    updateItem = () => {},
    changeItem = () => {},
    removeItem,
    addLabel,
    required = false,
    isOfferTodoLabelClass = '',
    error = {},
    isItemReadOnly = () => false,
  },
  { slots },
) => {
  const reqStar = required ? '*' : ''
  if (Array.isArray(fields)) {
    return [
      <p class={isOfferTodoLabelClass}>
        {label + ' ' + reqStar}: {slots.default ? <Help>{slots.default()}</Help> : ''}
      </p>,
      <div class="dynamic-input fields" id={_id}>
        {map(items, (item, i) => {
          const readOnly = isItemReadOnly(item)
          return (
            <div>
              <div class="removable-input">
                {map(fields, (field, j) =>
                  field.type == 'button' ? (
                    <button
                      class={item[field.key] ? 'dynamic-button success' : 'dynamic-button'}
                      disabled={readOnly}
                      onClick={() =>
                        !readOnly &&
                        items.forEach((innerItem, innerIndex) => {
                          innerIndex == i
                            ? updateItem(innerIndex, field.key, !item[field.key])
                            : !field.multiple
                              ? updateItem(innerIndex, field.key, false)
                              : null
                        })
                      }
                    >
                      {field.label}
                    </button>
                  ) : (
                    <label class={field.type}>
                      <span>{field.label}:</span>
                      {field.type === 'dropdown' ? (
                        <DropDown
                          id={`dynamic-input-${i}-${j}`}
                          label={null}
                          value={item[field.key]}
                          disabled={readOnly}
                          update={(value) => !readOnly && updateItem(i, field.key, value)}
                          items={
                            readOnly
                              ? field.items.map((option) =>
                                  option.value === item[field.key] ? { ...option, label: `${option.label} (connected)` } : option,
                                )
                              : field.items
                          }
                          default={field.default}
                        />
                      ) : field.isDecimal ? (
                        <Input
                          id={`dynamic-input-${i}-${j}`}
                          tabIndex={0}
                          type={field.type}
                          value={item[field.key]}
                          placeholder={field.placeholder}
                          isDecimal
                          isPercentage={field.isPercentage}
                          disabled={readOnly}
                          update={(value) => !readOnly && updateItem(i, field.key, value)}
                        />
                      ) : (
                        <input
                          id={`dynamic-input-${i}-${j}`}
                          tabIndex="0"
                          type={field.type}
                          value={item[field.key]}
                          placeholder={field.placeholder}
                          disabled={readOnly}
                          isPercentage={field.isPercentage}
                          onInput={(e) => !readOnly && updateItem(i, field.key, e.target.value)}
                          onChange={(e) => !readOnly && changeItem({ index: item.id || i, key: field.key, value: e.target.value })}
                        />
                      )}
                    </label>
                  ),
                )}
                <button type="button" disabled={readOnly} onClick={() => !readOnly && removeItem(item.id)}>
                  <trash-icon />
                </button>
              </div>
              {error.message && error.indexList.includes(item.id) && <div class="error">{error.message}</div>}
            </div>
          )
        })}
        <div class="align-right">
          <button type="button" class="link-basic" onClick={_addItem(addItem, fields.length, _id)}>
            <plus-icon /> <span>{addLabel}</span>
          </button>
        </div>
      </div>,
    ]
  }

  return [
    <p>
      {label + ' ' + reqStar}: {slots.default ? <Help>{slots.default()}</Help> : ''}
    </p>,
    <div id={_id}>
      {map(items, ({ id, value }) => (
        <div>
          <div class="removable-input">
            <input
              id={`dynamic-input-${id}`}
              tabIndex="0"
              type="text"
              value={value}
              placeholder={placeholder}
              onInput={(e) => updateItem(id, e.target.value)}
            />
            <button type="button" onClick={() => removeItem(id)}>
              <trash-icon />
            </button>
          </div>
        </div>
      ))}
      <div class="align-right">
        <button type="button" class="link-basic" onClick={_addItem(addItem, 1, _id)}>
          <plus-icon /> <span>{addLabel}</span>
        </button>
      </div>
    </div>,
  ]
}
export default DynamicInput
</script>
<style scoped>
.dynamic-button {
  margin-top: 22px;
  font-size: 16px;
  width: max-content;
  background: #e2e2e2;
}
.dynamic-button.success {
  background: #28a745;
}
</style>
